import PropTypes from 'prop-types';
import AntdButton from 'antd/lib/button';
import 'antd/lib/button/style/css';
import styled from 'styled-components';
import React from 'react';
// STYLED COMPONENTS
// ====================================

// we need to white label out props we don't want passed down... I do this one at a time as I see the errors in the browser console (unfortuantely)
// https://github.com/styled-components/styled-components/issues/135
// https://stackoverflow.com/questions/49834251/how-to-extend-styled-component-without-passing-props-to-underlying-dom-element?rq=1
// remove extra props before passing props to antd's button
const ButtonWrapper = ({ startCallingToMachine, fullWidth, ...rest }) => <AntdButton {...rest} />;

// wrap our antd button in styled, so we can add styles
const Button = styled(ButtonWrapper)`
  width: ${p => {
    if (p.style.width) {
      return p.style.width;
    }
    if (p.fullWidth) {
      return '100%';
    }
    return 'inherit';
  }} !important;

  height: ${p => (p.style.height ? p.style.height : '33px')} !important;
  font-size: 13px !important;
  max-width: 100% !important;
  display: inline-block !important;
  text-align: center !important;
  padding: 0 15px;
  margin: auto;
  background-color: ${p => {
    if (p.dark1) {
      return `${p.theme.colorDark1} !important`;
    }
    if (p.dark) {
      return `${p.theme.colorDark2} !important`;
    }
    return 'inherit';
  }};
  border: ${p => (p.dark || p.dark1 ? `1px solid ${p.theme.colorDark2}!important` : 'inherit')};
  color: ${p => (p.dark ? '#fff !important' : 'inherit')};
`;

// PROPS
// ====================================
Button.defaultProps = {
  loading: false,
  disabled: false,
  onClick: () => {},
  size: 'large',
  type: 'primary',
  fullWidth: false,
  children: '',
  style: {},
  dark: false,
};

Button.propTypes = {
  loading: PropTypes.bool,
  type: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  dark: PropTypes.bool,
};

// EXPORT
// ====================================
export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/index.js